import { Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { getVerticalAlignment } from "../../../../viewer/chart/style/legend/getVerticalAlignment.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { selectChartSettingsState } from "../../../../../store/selectors/fieldsStateSelectors.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import type { LegendSettings } from "../../../../../../../../../api/types/svTypes.ts";

export default function VerticalAlignmentItem({ readonlyMode }: { readonlyMode: boolean }) {
  const settings = useSelector(selectChartSettingsState);
  const alignment = React.useMemo(() => getVerticalAlignment(settings), [settings]);
  const dispatch = useAppDispatch();

  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <Typography sx={{ color: "text.secondary" }}>Vertical Alignment</Typography>
      <HorizontalFill />
      <ToggleButtonGroup
        exclusive
        color="primary"
        value={alignment}
        disabled={readonlyMode}
        onChange={(_, value: LegendSettings["verticalAlignment"]) => {
          if (value !== null) dispatch(fieldsStateActions.updateLegendSettings({ verticalAlignment: value }));
        }}
      >
        <ToggleButton value="top" sx={{ py: 0.3, fontWeight: 400 }}>
          Top
        </ToggleButton>
        <ToggleButton value="bottom" sx={{ py: 0.3, fontWeight: 400 }}>
          Bottom
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
}
